/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolBookIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-book"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M5.9 22.8Q4.8 22.8 4.03 22.02Q3.25 21.25 3.25 20.15L3.25 3.85Q3.25 2.75 4.03 1.98Q4.8 1.2 5.9 1.2L18.1 1.2Q19.2 1.2 19.98 1.98Q20.75 2.75 20.75 3.85L20.75 20.15Q20.75 21.25 19.98 22.02Q19.2 22.8 18.1 22.8ZM11.32 3.85L11.32 9.7Q11.32 10.07 11.65 10.26Q11.97 10.45 12.32 10.25L13.13 9.78Q13.45 9.57 13.81 9.57Q14.18 9.57 14.5 9.78L15.3 10.25Q15.65 10.45 15.99 10.26Q16.32 10.07 16.32 9.7L16.32 3.85Z" fill={color} />
    </svg>
  );
}
